const AMENDMENT_FIELD_LABELS = {
  period: "Période",
  qualification: "Qualification",
  salary: "Rémunération",
  schedule: "Planning",
  address: "Adresse",
  reason: "Motif",
  licences: "Permis",
  languages: "Langue",
  tools: "Matériel",
  reference: "Référence",
  other: "Informations pour le candidat",
  other_interim: "Informations pour l'agence",
};

function formatDateFR(d) {
  return new Date(d).toLocaleDateString("fr-FR");
}

function formatPeriod(val) {
  if (!val) return "";
  if (val.start && val.end)
    return `${formatDateFR(val.start)} → ${formatDateFR(val.end)}`;
  return String(val);
}

function formatChangeValue(field, value) {
  if (field === "period" && typeof value === "object" && value !== null)
    return formatPeriod(value);
  if (typeof value === "object" && value !== null) return JSON.stringify(value);
  return String(value ?? "");
}

function getFieldLabel(field) {
  return AMENDMENT_FIELD_LABELS[field] || field;
}

export { formatChangeValue, getFieldLabel, formatPeriod };
